

export class ToolTipOptionStatusInput implements IToolTipOptionStatusInput {
    /** The auto-generated id of the tool tip option master */
    tooltipOptionId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IToolTipOptionStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltipOptionId = _data["tooltipOptionId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ToolTipOptionStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipOptionStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltipOptionId"] = this.tooltipOptionId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IToolTipOptionStatusInput {
    /** The auto-generated id of the tool tip option master */
    tooltipOptionId: number;
    /** The updated status */
    status: number;
}

